import React from "react";
import playmusic from "../assets/img/playmusic.png";
import Footer from "../components/footer/Footer";
export default function PlayMusic() {
  const myPlaylist = [1, 2, 3, 4, 5, 6, 7, 8];
  return (
    <div className="playmusic-wrapper">
      <div
        className="price"
        style={{
          marginTop: "-14px",
          fontSize: "12px",
          fontFamily: "sans-serif",
        }}
      >
        <div>
          <div style={{ marginBottom: "4px" }}> 1 Music = $USD 0.452</div>
          <div> 1 BNB = $USD 0.452 </div>
        </div>
      </div>
      <div
        style={{ display: "flex", alignItems: "center" }}
        className="playlist-back"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="16"
          fill="currentColor"
          className="bi bi-arrow-left"
          viewBox="0 0 16 16"
        >
          <path
            fillRule="evenodd"
            d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
          />
        </svg>
        <div style={{ marginLeft: "20px" }}>Back to My Playlist</div>
      </div>

      <div className="playmusic-contain">
        <div className="playmusic-info-left">
          <div className="playmusic-card">
            <div className="playmusic-card-title">
              <div>March 2021 Hot Tracks</div>

              <div style={{ marginTop: "12px" }}>Artist name</div>
            </div>
            <div className="playmusic-card-image">
              <img src={playmusic} alt="no" />
            </div>
            <div className="nft-likes">
              <svg
                style={{ marginRight: "6px" }}
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="#CFC7C4"
                class="bi bi-suit-heart-fill"
                viewBox="0 0 16 16"
              >
                <path d="M4 1c2.21 0 4 1.755 4 3.92C8 2.755 9.79 1 12 1s4 1.755 4 3.92c0 3.263-3.234 4.414-7.608 9.608a.513.513 0 0 1-.784 0C3.234 9.334 0 8.183 0 4.92 0 2.755 1.79 1 4 1z" />
              </svg>
              9.99k
            </div>

            <div className="playmusic-card-desc">
              {" "}
              <div className="nft-description">
                Description for playlist set by playlist owner. Owner can
                explain whatever he wants, for example if the playlist is made
                for certain mood, time of the day or music genre.{" "}
              </div>
            </div>
            <div className="playmusic-card-buttons">
              <div className="nft-buttons">
                <div>Indie</div>
                <div>Pop</div>
                <div>r&B</div>
              </div>
            </div>
          </div>
          <svg
            style={{ marginLeft: "20px", marginTop: "20px" }}
            xmlns="http://www.w3.org/2000/svg"
            width="35"
            height="35"
            viewBox="0 0 35 35"
          >
            <g
              id="Group_1357"
              data-name="Group 1357"
              transform="translate(-482 -212)"
            >
              <g
                id="Group_1349"
                data-name="Group 1349"
                transform="translate(0 46)"
              >
                <path
                  id="Path_3563"
                  data-name="Path 3563"
                  d="M17.5,0A17.5,17.5,0,1,1,0,17.5,17.5,17.5,0,0,1,17.5,0Z"
                  transform="translate(482 166)"
                  fill="#4176d9"
                />
                <g
                  id="Group_1351"
                  data-name="Group 1351"
                  transform="translate(469 174.856)"
                >
                  <path
                    id="Path_3555"
                    data-name="Path 3555"
                    d="M340.561,18.446A2.446,2.446,0,1,1,338.114,16,2.446,2.446,0,0,1,340.561,18.446Z"
                    transform="translate(-303.565 -15.435)"
                    fill="#fff"
                  />
                  <path
                    id="Path_3556"
                    data-name="Path 3556"
                    d="M322.679,6.022a3.011,3.011,0,1,1,3.011-3.011A3.014,3.014,0,0,1,322.679,6.022Zm0-4.893a1.882,1.882,0,1,0,1.882,1.882A1.884,1.884,0,0,0,322.679,1.129Z"
                    transform="translate(-288.13)"
                    fill="#fff"
                  />
                  <path
                    id="Path_3557"
                    data-name="Path 3557"
                    d="M340.561,359.779a2.446,2.446,0,1,1-2.446-2.447A2.446,2.446,0,0,1,340.561,359.779Z"
                    transform="translate(-303.565 -344.724)"
                    fill="#fff"
                  />
                  <path
                    id="Path_3558"
                    data-name="Path 3558"
                    d="M322.679,347.354a3.011,3.011,0,1,1,3.011-3.011A3.014,3.014,0,0,1,322.679,347.354Zm0-4.893a1.882,1.882,0,1,0,1.882,1.882A1.884,1.884,0,0,0,322.679,342.461Z"
                    transform="translate(-288.13 -329.288)"
                    fill="#fff"
                  />
                  <path
                    id="Path_3559"
                    data-name="Path 3559"
                    d="M41.893,189.114a2.446,2.446,0,1,1-2.447-2.446A2.446,2.446,0,0,1,41.893,189.114Z"
                    transform="translate(-15.435 -180.081)"
                    fill="#fff"
                  />
                  <path
                    id="Path_3560"
                    data-name="Path 3560"
                    d="M24.011,176.69a3.011,3.011,0,1,1,3.011-3.011A3.014,3.014,0,0,1,24.011,176.69Zm0-4.893a1.882,1.882,0,1,0,1.882,1.882A1.884,1.884,0,0,0,24.011,171.8Z"
                    transform="translate(0 -164.646)"
                    fill="#fff"
                  />
                  <path
                    id="Path_3561"
                    data-name="Path 3561"
                    d="M136.1,95.7a.753.753,0,0,1-.373-1.407l6.985-3.982a.753.753,0,1,1,.745,1.308L136.474,95.6A.748.748,0,0,1,136.1,95.7Z"
                    transform="translate(-110.314 -87.031)"
                    fill="#fff"
                  />
                  <path
                    id="Path_3562"
                    data-name="Path 3562"
                    d="M143.108,271.707a.748.748,0,0,1-.372-.1l-6.985-3.982a.753.753,0,0,1,.745-1.308l6.985,3.982a.753.753,0,0,1-.373,1.407Z"
                    transform="translate(-110.336 -256.825)"
                    fill="#fff"
                  />
                </g>
              </g>
            </g>
          </svg>
        </div>
        <div className="playmusic-info-right">
          <div className="playmusic-list">
            {myPlaylist.map((item, i) => {
              return (
                <div className="playmusic-eachmusic">
                  <div>Play music</div>
                  <div>2.09</div>
                  <div>
                    <svg
                      id="Group_1378"
                      data-name="Group 1378"
                      xmlns="http://www.w3.org/2000/svg"
                      width="29.76"
                      height="28.697"
                      viewBox="0 0 29.76 28.697"
                    >
                      <ellipse
                        id="Ellipse_97"
                        data-name="Ellipse 97"
                        cx="14.88"
                        cy="14.348"
                        rx="14.88"
                        ry="14.348"
                        fill="#ebe3e1"
                      />
                      <g
                        id="icons_Play_Filled"
                        data-name="icons/Play/Filled"
                        transform="translate(8.503 8.503)"
                      >
                        <path
                          id="Shape"
                          d="M2.355.233,8.68,4.149a1.543,1.543,0,0,1,0,2.623L2.355,10.688A1.543,1.543,0,0,1,0,9.377V1.545A1.543,1.543,0,0,1,2.355.233Z"
                          transform="translate(1.904 0.71)"
                          fill="#574c4f"
                        />
                      </g>
                    </svg>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="music-player">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              // xmlns:xlink="http://www.w3.org/1999/xlink"
              width="440.897"
              height="127.713"
              viewBox="0 0 440.897 127.713"
            >
              <defs>
                <filter
                  id="Frame_1038_Background_"
                  x="0"
                  y="0"
                  width="437.174"
                  height="127.713"
                  filterUnits="userSpaceOnUse"
                >
                  <feOffset dy="8" input="SourceAlpha" />
                  <feGaussianBlur stdDeviation="8" result="blur" />
                  <feFlood flood-color="#0f0f0f" flood-opacity="0.2" />
                  <feComposite operator="in" in2="blur" />
                  <feComposite in="SourceGraphic" />
                </filter>
                <clipPath id="clip-path">
                  <rect
                    id="Frame_1037_Background_Mask_"
                    data-name="Frame 1037 (Background/Mask)"
                    width="257.955"
                    height="7.758"
                    rx="3.879"
                    fill="#e6e8ec"
                  />
                </clipPath>
                <clipPath id="clip-path-2">
                  <rect
                    id="Frame_1039_Background_Mask_"
                    data-name="Frame 1039 (Background/Mask)"
                    width="26.94"
                    height="7.758"
                    rx="3.879"
                    fill="#3772ff"
                  />
                </clipPath>
              </defs>
              <g
                id="Group_1113"
                data-name="Group 1113"
                transform="translate(22.799 16)"
              >
                <g
                  transform="matrix(1, 0, 0, 1, -22.8, -16)"
                  filter="url(#Frame_1038_Background_)"
                >
                  <rect
                    id="Frame_1038_Background_2"
                    data-name="Frame 1038 (Background)"
                    width="389.174"
                    height="79.713"
                    rx="39.856"
                    transform="translate(24 16)"
                    fill="none"
                  />
                </g>
                <path
                  id="Frame_1038_Background_Copy"
                  data-name="Frame 1038 (Background) Copy"
                  d="M25.809,0h370.98a26.041,26.041,0,0,1,0,52.079H25.809A26.041,26.041,0,0,1,25.809,0Z"
                  transform="translate(-5 13.817)"
                  fill="#fcfcfd"
                  stroke="#b0a39e"
                  stroke-width="1"
                />
                <g id="Group" transform="translate(319.165 31.885)">
                  <text
                    id="_2:20"
                    data-name="2:20"
                    transform="translate(0 12.841)"
                    fill="#23262f"
                    font-size="14"
                    font-family="Raleway-Medium, Raleway"
                    font-weight="500"
                  >
                    <tspan x="0" y="0">
                      2:09
                    </tspan>
                  </text>
                  <g
                    id="icons_Volume_Filled"
                    data-name="icons/Volume/Filled"
                    transform="translate(33.691 -0.547)"
                  >
                    <path
                      id="Shape"
                      d="M.724,11.582a.724.724,0,1,1,0-1.448,4.343,4.343,0,1,0,0-8.686A.724.724,0,1,1,.724,0a5.791,5.791,0,1,1,0,11.582Zm0-2.9a.724.724,0,1,1,0-1.448,1.448,1.448,0,1,0,0-2.9.724.724,0,0,1,0-1.448,2.9,2.9,0,1,1,0,5.791Z"
                      transform="translate(10.858 2.894)"
                      fill="#d3c7c3"
                    />
                    <path
                      id="Shape-2"
                      data-name="Shape"
                      d="M6.972.394A1.448,1.448,0,0,1,9.41,1.451V9.968a1.448,1.448,0,0,1-2.438,1.056L3.619,7.881H1.448A1.448,1.448,0,0,1,0,6.433V4.985A1.448,1.448,0,0,1,1.448,3.538H3.619Z"
                      transform="translate(0 2.976)"
                      fill="#d3c7c3"
                    />
                  </g>
                  <path
                    id="Path_3565"
                    data-name="Path 3565"
                    d="M13.728,2.735l-.622.8a4.663,4.663,0,1,1-2.6-.971l-.875.918.649.619,1.381-1.45h0L12.278,2l-.649-.619h0L10.179,0,9.56.65l.945.9A5.673,5.673,0,0,0,9.366,12.82,5.674,5.674,0,0,0,13.728,2.735Z"
                    transform="translate(56.83 1.476)"
                    fill="#d3c7c3"
                    stroke="#d3c7c3"
                    stroke-width="0.4"
                  />
                </g>
                <g
                  id="Group_2"
                  data-name="Group 2"
                  transform="translate(21.395 25.508)"
                >
                  <g
                    id="Status_Desktop"
                    data-name="Status / Desktop"
                    transform="translate(34.751 12.436)"
                  >
                    <g id="Frame_1037" data-name="Frame 1037">
                      <rect
                        id="Frame_1037_Background_Mask_2"
                        data-name="Frame 1037 (Background/Mask)"
                        width="257.955"
                        height="7.758"
                        rx="3.879"
                        fill="#ebe3e1"
                      />
                      <g
                        id="Frame_1037-2"
                        data-name="Frame 1037"
                        clip-path="url(#clip-path)"
                      >
                        <g id="Frame_1039" data-name="Frame 1039">
                          <rect
                            id="Frame_1039_Background_Mask_2"
                            data-name="Frame 1039 (Background/Mask)"
                            width="26.94"
                            height="7.758"
                            rx="3.879"
                            fill="#68cad8"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g id="Group_1219" data-name="Group 1219">
                    <ellipse
                      id="Ellipse_97"
                      data-name="Ellipse 97"
                      cx="14.88"
                      cy="14.348"
                      rx="14.88"
                      ry="14.348"
                      fill="#ebe3e1"
                    />
                    <g
                      id="icons_Play_Filled"
                      data-name="icons/Play/Filled"
                      transform="translate(8.503 8.503)"
                    >
                      <path
                        id="Shape-3"
                        data-name="Shape"
                        d="M2.355.233,8.68,4.149a1.543,1.543,0,0,1,0,2.623L2.355,10.688A1.543,1.543,0,0,1,0,9.377V1.545A1.543,1.543,0,0,1,2.355.233Z"
                        transform="translate(1.904 0.71)"
                        fill="#574c4f"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
